// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Q_ip","list":"PatternAutocomplete_list__3mGR_"};